import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import ImageDropzone from "./ImageDropzone";
import crossIcon from "../assets/photos/crossIcon.svg";
import { AppContext } from "../context/context";
import { addPromptQuestion, editPromptQuestion } from "../hooks/addOrEditPromptQuestion";

const EditQuestionsModal = ({
  modalOpen,
  selectedItem,
  handleModalClose,
  fetchPromptQuestions
}) => {
  const { state } = useContext(AppContext);
  const [file, setFile] = useState();
  const [image, setImage] = useState(selectedItem.image_url);
  const [question, setQuestion] = useState(selectedItem.text);
  const [loading, setLoading] = useState(false);
  const [showDropzone, setShowDropzone] = useState(false);

  const handleSubmit = async () => {
    if (!question || !image) {
      toast.error("Please fill all required fields");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        source: state.activeTab === "ABCD App" ? "abcd_app" : "service_app",
        id: modalOpen === "edit" ? selectedItem.id : " ",
        text: question,
        file: file
      };

      if (modalOpen === "edit") {
        await editPromptQuestion(payload);
      } else {
        await addPromptQuestion(payload);
      }
      toast.success(
        `Question ${modalOpen === "edit" ? "updated" : "added"} successfully!`
      );
      handleModalClose();
      await fetchPromptQuestions();
    } catch (error) {
      console.error("Error submitting question:", error);
      toast.error(error?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const handleClearImage = () => {
    setFile({});
    setShowDropzone(true);
  };

  const handleFileChange = (files) => {
    if (files && files[0]) {
      const fileUrl = URL.createObjectURL(files[0]);
      setImage(fileUrl);
      setFile(files[0]);
      setShowDropzone(false);
    }
  };

  return (
    <div className="editPdfModal flex items-center justify-center h-full w-screen absolute inset-0 bg-[grey] z-[1] bg-opacity-50">
      <div className="modal bg-white rounded-md p-6 w-[30rem] relative">
        <div
          onClick={handleModalClose}
          className="w-7 h-7 p-2 absolute top-[8px] right-[15px] cursor-pointer"
        >
          <img className="h-[20px]" src={crossIcon} alt="" />
        </div>
        <div className="modal-header text-center text-xl text-[#424242] font-medium">
          {modalOpen === "edit" ? "Edit Question" : "Add Question"}
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col">
            <label className="text-sm text-[#676767] mb-1">Question</label>
            <input
              onChange={(e) => {
                setQuestion(e.target.value);
              }}
              value={question}
              className="p-2 rounded-[4px] text-[#8A8A8A] text-sm border-[0.5px] border-[#E3E3E3] disabled:cursor-not-allowed"
            />
          </div>

          <div className="flex flex-col">
            <label className="text-sm text-[#676767] mb-1">Uploaded Icon</label>
            {image && !showDropzone ? (
              <div className="relative w-20 h-20 border border-[#E3E3E3] rounded-md overflow-hidden">
                <img
                  src={image}
                  alt="Question icon"
                  className="w-full h-full object-cover"
                />
              </div>
            ) : (
              <div className="dropZone cursor-pointer">
                <ImageDropzone
                  files={file}
                  multiSelect={false}
                  setFiles={handleFileChange}
                />
              </div>
            )}
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-[#C7222A] text-white text-sm flex items-center justify-center w-full h-[39px] rounded-[4px] disabled:cursor-not-allowed"
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditQuestionsModal;

async function blobUrlToBinary(blobUrl) {
  try {
    // Fetch the Blob from the Blob URL
    const response = await fetch(blobUrl);
    const blob = await response.blob();

    // Convert the Blob to an ArrayBuffer
    const arrayBuffer = await blob.arrayBuffer();

    // Optionally, convert the ArrayBuffer to a Uint8Array for binary representation
    const binary = new Uint8Array(arrayBuffer);

    console.log(binary); // The binary data of the image
    return binary;
  } catch (error) {
    console.error("Error converting Blob URL to binary:", error);
  }
}
